/* ==========================================================================
   Alwayz Clean Lab - finder.js
   <concern-finder>: pick a concern → products for that concern load from its
   collection via the Section Rendering API (cached, prefetched on hover).
   ========================================================================== */
(() => {
  'use strict';
  const A = window.Alwayz;
  const { $, $$, define, fetchHTML, parseHTML } = A;

  class ConcernFinder extends HTMLElement {
    connectedCallback() {
      this.chips = $$('[data-concern]', this);
      this.results = $('[data-finder-results]', this);
      this.titleEl = $('[data-finder-title]', this);
      this.tipEl = $('[data-finder-tip]', this);
      this.cache = new Map();
      this.chips.forEach((chip) => {
        chip.addEventListener('click', () => this.select(chip));
        chip.addEventListener('pointerenter', () => this.load(chip.dataset.url).catch(() => {}));
        chip.addEventListener('focus', () => this.load(chip.dataset.url).catch(() => {}));
      });
      const hash = decodeURIComponent(location.hash.replace('#', '')).toLowerCase();
      const preset = hash && this.chips.find((c) => c.dataset.title.toLowerCase() === hash);
      if (preset) this.select(preset);
    }
    load(url) {
      if (!url) return Promise.reject(new Error('no url'));
      if (!this.cache.has(url)) {
        const sep = url.includes('?') ? '&' : '?';
        this.cache.set(url, fetchHTML(`${url}${sep}section_id=concern-results`).then((html) => {
          const el = $('[data-finder-payload]', parseHTML(html));
          return el ? el.innerHTML : '';
        }));
      }
      return this.cache.get(url);
    }
    async select(chip) {
      this.chips.forEach((c) => { const on = c === chip; c.classList.toggle('is-active', on); c.setAttribute('aria-selected', String(on)); });
      this.titleEl.textContent = chip.dataset.title;
      const tip = chip.dataset.tip;
      this.tipEl.innerHTML = tip ? `<span class="finder__tip-tag">${this.dataset.tipLabel || 'Tip'}</span> ${tip.replace(/</g, '&lt;')}` : '';
      this.results.classList.add('is-loading');
      try {
        const html = await this.load(chip.dataset.url);
        if (!chip.classList.contains('is-active')) return;
        this.results.innerHTML = html;
        A.reveal && A.reveal.scan(this.results);
      } catch (err) { /* keep previous results */ }
      this.results.classList.remove('is-loading');
    }
  }
  define('concern-finder', ConcernFinder);
})();
